import { ViewUtils } from "../../../util/view/ViewUtils";
import { TitanSprite } from "../../control/TitanSprite";
import { AbstractView } from "../AbstractView";
/**
 * DemoPlay.ts
 */
export class DemoPlay extends AbstractView {
    constructor(properties, portraitProperties) {
        super(properties, portraitProperties);
        this.landscapeProperties = properties;
        this.portraitProperties = portraitProperties;
        this.uiProperties = this.uiProperties;
        this.run();
    }
    create() {
        super.create();
        this.createModel();
        this.createBackground();
        this.createLabel();
        this.responsive = true;
    }
    createBackground() {
        this.background = TitanSprite.createSprite(this, "background", this.landscapeProperties.backgroundProperties, this.portraitProperties?.backgroundProperties);
    }
    createLabel() {
        this.label = ViewUtils.createField(this.background, this.landscapeProperties.labelProperties, this.portraitProperties?.labelProperties);
    }
    handleResize(event) {
        if (this.renderer.isLandscape()) {
            this.anchorTop(this, this.uiProperties.position, 0);
            this.anchorLeft(this, this.uiProperties.position, 0);
            let screenX = Math.min(this.getGlobalPosition().x, 0);
            let safeTransformX = (screenX / this.renderer.getHolder().scale.x);
            this.x -= safeTransformX;
        }
        else {
            this.anchorTop(this, this.uiProperties.position, 0);
            let screenY = Math.min(this.getGlobalPosition().y, 0);
            let safeTransformY = (screenY / this.renderer.getHolder().scale.y);
            this.y -= safeTransformY;
        }
    }
    handleRotate(event) {
        super.handleRotate(event);
        this.uiProperties = this.uiProperties;
    }
}
//# sourceMappingURL=DemoPlay.js.map